var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.advanced
        ? _c("div", { staticClass: "col-xs-3 col-sm-2 col-md-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.allTime,
                  expression: "allTime",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control m-b-0",
              attrs: {
                type: "number",
                min: "0",
                "ng-readonly": "vm.isReadOnly"
              },
              domProps: { value: _vm.allTime },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) return
                    _vm.allTime = _vm._n($event.target.value)
                  },
                  _vm.allTimeChange
                ],
                wheel: function($event) {
                  return $event.target.blur()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pull-left p-l-15 m-r-15" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-success btn-sm width-100",
            attrs: { type: "button" },
            on: { click: _vm.togleAdvanced }
          },
          [
            !_vm.advanced
              ? _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "TARGET_CONCURRENCY_ADVANCED_BUTTON",
                      expression: "'TARGET_CONCURRENCY_ADVANCED_BUTTON'"
                    }
                  ]
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.advanced
              ? _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "TARGET_CONCURRENCY_BASIC_BUTTON",
                      expression: "'TARGET_CONCURRENCY_BASIC_BUTTON'"
                    }
                  ]
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("button", {
        directives: [
          { name: "t", rawName: "v-t", value: "RESET", expression: "'RESET'" }
        ],
        staticClass: "btn btn-primary btn-sm m-r-10",
        attrs: { type: "button" },
        on: { click: _vm.resetMatrix }
      }),
      _vm._v(" "),
      _vm.matrixData && _vm.advanced
        ? _c("HourlyDayMatrix", {
            attrs: {
              matrix: _vm.matrixData,
              allDays: _vm.allDays,
              allHours: _vm.allHours,
              allTime: _vm.allTime
            },
            on: {
              matrixNeedsUpdate: _vm.matrixNeedsUpdate,
              matrixHourNeedsUpdate: _vm.matrixHourNeedsUpdate,
              matrixDayNeedsUpdate: _vm.matrixDayNeedsUpdate
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }